var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"title":_vm.title,"items":_vm.items}},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('Calendario')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }